import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { Button, Dialog } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import i18next from 'i18next';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const TutorialVideo = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [play, setPlay] = useState(true)
  const [mute, setMute] = useState(true)
  const [openDialog, setOpenDialog] = useState(true)
  const [gender, setGender] = useState('')

  let { Gender } = useSelector((state) => state.user.profile);

  useEffect(() => {
    if(Gender == ''){
      setGender(localStorage.getItem('gender'))
    } else {
      setGender(Gender)
    }
    setMute(false)
  }, [])

  return (
    <div className='tutorialVidPage'>
      <Dialog
        open={openDialog}
        className='tutorialVidDialog'
        maxWidth={"sm"}
      >
        {
          (location?.state?.from === 'expandVideo' || location?.state?.from === 'needhelp') &&
            <div 
              onClick={() => 
              {
                location?.state?.from === 'expandVideo' ? 
                  navigate('/onboardingslider', {state: { from: 'expandVideo' }})
                    :
                  navigate("/taketest", { replace: true, state: location?.state?.from ? "needhelp" : "onboardingComplete"})
              }
              } 
              className="closeicon expandVid cursor-pointer"
            >
              <CancelOutlinedIcon></CancelOutlinedIcon>
            </div>
        }
        <h3 className='mt-10px mb-10px'>{i18next.t("Hair Test Guide")}</h3>
        <ReactPlayer
          url={
            gender.toUpperCase() === "MALE" ?
              'https://res.cloudinary.com/dgeiynco8/video/upload/v1751006680/tutorial_male_lcmqfi.mp4' 
                  :
              'https://res.cloudinary.com/dgeiynco8/video/upload/v1751006705/tutorial_female_a0puem.mp4'
          }
          playing={play}        // Autoplay
          controls={false}      // Hide controls
          muted={mute}          // Required for autoplay to work in browsers
          onEnded={() => setPlay(!play)}
          config={{
            file: {
              attributes: {
                playsInline: true,
                webkitPlaysInline: true, // for older iOS versions
              }
            }
          }}
        />
        <div className={(location?.state?.from === 'expandVideo' || location?.state?.from === 'needhelp') ? 'btnControls expandVid' : 'btnControls'}>
          <Button onClick={() => setMute(!mute)}>
            {
              mute ?
                <VolumeOffIcon/> 
                  :
                <VolumeUpIcon/>
            }
          </Button>
          {
            !play && 
              <Button onClick={() => setPlay(true)}>
                <ReplayIcon/>
              </Button>
          }
        </div>
        {/* {
          !play && !location?.state?.from === 'expandVideo' && 
            <div className='continuebtndiv'>
              <Button onClick={() => navigate("/taketest", { replace: true, state: location?.state?.from ? "needhelp" : "onboardingComplete"})}>
                Continue
              </Button>
            </div>
        } */}
      </Dialog>
    </div>
  )
}

export default TutorialVideo